import Head from "next/head";
import { GetServerSideProps } from "next";
import { LoginCard } from "components/web-checkout/login-card/login-card";
import { LoginBackground } from "components/web-checkout/login-background/login-background";
import { ILoginPageProps } from "types/page.types";
import { LoadingSpinner } from "components/icons/loading-spinner";
import { PageLoader } from "styles/common/pageLoader";
import { useLogin } from "hooks/pages/use-login/use-login";

const Login: React.FC<ILoginPageProps> = ({ documentReferrer }) => {
  const { isUserLoggedIn, routerPath, setFormPhase, formPhase, prevLink } =
    useLogin({
      documentReferrer
    });

  if (isUserLoggedIn) {
    return (
      <PageLoader>
        <LoadingSpinner />
      </PageLoader>
    );
  }

  return (
    <LoginBackground routerPath={routerPath} prevLink={prevLink}>
      <Head>
        <title>CoLearn | Masuk ke website</title>
      </Head>
      <LoginCard setFormPhase={setFormPhase} formPhase={formPhase} />
    </LoginBackground>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const documentReferrer = req.headers.referer ? req.headers.referer : "";
  return {
    props: {
      documentReferrer
    }
  };
};

export default Login;
